import './App.css';
import Sortingalgo from './Components/Sortingalgo'

function App() {
  return (
    <main>
        <Sortingalgo />
    </main>
  );
}

export default App;
